<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="orderConfirmationRecords"
        :table-action="true"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn"/>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="工单号" prop="billNo">
            <el-input v-model="filter.billNo" clearable/>
          </el-form-item>
          <el-form-item label="物料号" prop="materialNo">
            <el-input v-model="filter.materialNo" clearable/>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createDateBegin', 'createDateEnd')"/>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker
                v-model="endDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('endDateRange', 'endDateBegin', 'endDateEnd')"/>
          </el-form-item>
          <el-form-item label="工序" prop="station">
            <el-input v-model="filter.station" clearable/>
          </el-form-item>
          <el-form-item label="sn号" prop="sn">
            <el-input v-model="filter.sn" clearable/>
          </el-form-item>
          <el-form-item label="创建ip地址" prop="createIpAddress">
            <el-input v-model="filter.createIpAddress" clearable/>
          </el-form-item>
          <el-form-item label="结束ip地址" prop="endIpAddress">
            <el-input v-model="filter.endIpAddress" clearable/>
          </el-form-item>
          <el-form-item label="工序码" prop="standardCode">
            <el-input v-model="filter.standardCode" clearable/>
          </el-form-item>
          <el-form-item label="工序名称" prop="procedureName">
            <el-input v-model="filter.procedureName" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <order-confirmation-record-edit
        :visible.sync="editVisible"
        :data="editData"
        @submit="submitHandle"
    />
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import OrderConfirmationRecordEdit from "./OrderConfirmationRecordEdit.vue";

  export default {
    name: "OrderConfirmationRecordList",
    components: { viewTable, OrderConfirmationRecordEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(761),
          editAuth: this.$auth(762),
          delAuth: this.$auth(763),
        },
        filter: {
          isEnd: "",
          productionNo: "",
          station: "",
          componentMaterialNo: "",
          componentBarcode: "",
          createIpAddress: "",
          endIpAddress: "",
          standardCode: "",
          procedureName: "",
          createDateBegin:"",
          createDateEnd:"",
          endDateBegin:"",
          endDateEnd:"",
          materialNo:"",
        },
        selection: [],
        editVisible: false,
        editData: {},
        createDateRange: [],
        endDateRange: [],
        columnsProperty: [
          {
            tooltip: true, key: "billNo", width: 160, align: "center" },
          {
            tooltip: true, key: "station", width: 160, align: "center" },
          {
            tooltip: true, key: "sn", width: 160, align: "center" },
          {
            tooltip: true, key: "createIpAddress", width: 160, align: "center" },
          {
            tooltip: true, key: "endIpAddress", width: 160, align: "center" },
          {
            tooltip: true, key: "standardCode", width: 160, align: "center" },
          {
            tooltip: true, key: "procedureName", width: 150, align: "center"},
          {
            tooltip: true, key: "note", width: 150, align: "center" },
          { key: "action", width: 150, align: "center", slot: "action" },
        ],
      };
    },
    mounted() {
    },
    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "orderConfirmationRecords", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      resetHandle(filter) {
        this.filter = filter;
      },
      addEditHandle(row) {
        this.editData = row || {};
        this.editVisible = true;
      },
      submitHandle(form) {
        if (form.pkId) {
          // 编辑
          this.$http.put("basic", "orderConfirmationRecords", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("编辑成功");
            }
          });
        } else {
          // 新增
          this.$http.post("basic", "orderConfirmationRecords", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("新增成功");
            }
          });
        }
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
    },
  };
</script>